module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-fix-fouc@1.1.3_gatsby@5.15.0_babel-eslint@10.1.0_eslint@7.32.0__react-dom_f71c063c602aaca8a1470406d4c12004/node_modules/gatsby-plugin-fix-fouc/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@1_2dd2776d7444cafde0c8712f51186831/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
